import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { Company } from '../../models/company';
import { Division } from '../../models/division';
import { Department } from '../../models/department';
import { SubDepartment } from '../../models/subdepartment';
import { Unit } from '../../models/unit';
import { Designation } from '../../models/designation';
import { CompanyService } from '../../services/company.service';
import { DivisionService } from '../../services/division.service';
import { DepartmentService } from '../../services/department.service';
import { SubDepartmentService } from '../../services/subdepartment.service';
import { UnitService } from '../../services/unit.service';
import { DesignationService } from '../../services/designation.service';
import { FileUploaderService } from '../../services/fileuploader.service';
import { BasicMaster } from '../../models/basicmaster';
import { BasicMasterService } from '../../services/basicmaster.service';
import { PositionService } from '../../services/position.service';
import { Position } from '../../models/position';
import { Users } from '../../models/users';
import { Console } from 'console';
import { EmployeeSecretary } from '../../models/employeesecretary';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css']
})
export class EmployeeComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();
  @ViewChild('view') view!: TemplateRef<any>;
  headerEmployee: PageHeader;
  entity: Employee = new Employee();
  selectedEmployee: Employee = new Employee();
  editingEntity: Employee = new Employee();
  employees: any;
  employeeColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  IsEdit: boolean = false;
  companys: Array<Company> = [];
  selectedCompany: any;
  divisions: Array<Division> = [];
  selectedDivision: any;
  salutations: Array<BasicMaster> = [];
  locations: Array<Location> = [];
  selectedLocation: any;
  departments: Array<Department> = [];
  selectedSalutation: any;
  selectedDepartment: any;
  subdepartments: Array<SubDepartment> = [];
  selectedSubDepartment: any;
  units: Array<Unit> = [];
  selectedUnit: any;
  designations: Array<Designation> = [];
  selectedDesignation: any;
  positions: Array<Position> = [];
  selectedPosition: any;
  userdata:Array<Users>=[];
  secretarydata:Array<EmployeeSecretary>=[];
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  HOStaff: boolean = true;
  path: string = "";
  fileName: string = "";
  url = '';
  filterState: string =''
  // isButtonVisible: boolean = false; 
  contactCheck: boolean = true;
  opened: boolean = false;
  details: any;
  users_list!: any[];
  secretary_list!:any[];
  privateCommentsToentity: Users =new Users();
  PrivateComments:string="";
  PrivateCommentsColumns: any[] = [];

  constructor(
    private _employeeService: EmployeeService,
    private _companyService: CompanyService,
    private _divisionService: DivisionService,
    private _locationService: LocationService,
    private _departmentService: DepartmentService,
    private _subdepartmentService: SubDepartmentService,
    private _unitService: UnitService,
    private _designationService: DesignationService,
    private _positionService: PositionService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private fileUploader: FileUploaderService,
    private _basicMasterService: BasicMasterService,
  ) {
    this.headerEmployee = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));

    this.employees = [];
    this.getAllEmployee();
  }
  ngAfterViewInit(): void {
    this.employeeColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 80 },
      { field: "EmployeeCode", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: 'Salutation', title: 'Salutation', filter: true, sortable: true, width: 150 },
      { field: "EmployeeName", title: 'Name', filter: true, sortable: true, width: 150 },
      { field: "LocationName", title: 'Branch', filter: true, sortable: true, width: 150 },
      { field: "DepartmentName", title: 'Department', filter: true, sortable: true, width: 150 },
      { field: "EmpMail", title: 'Email Id', filter: true, sortable: true, width: 180 },
      { field: "EmpPhone", title: 'Phone', filter: true, sortable: true, width: 120 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 150 },
      { field: "", title: '', filter: true, sortable: true, width: 80, template: this.view }
    ];

    this.PrivateCommentsColumns = [
      { field: "UserName", title: 'Private Comments to', filter: false, sortable: true, width: 80 },
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._employeeService.getAllEmployees(this.filterState, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Employee>) => {
      this.employees = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllSalutation(filter: string) {
    this._basicMasterService.getBasicMastersByName('Salutation', filter, this.defaultRowsCount, 1).subscribe((data: Array<BasicMaster>) => {
      this.salutations = data;
    })
  }
  getAllCompanys(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.companys = data;
    })
  }
  getAllDivisions(filter: string) {
    this._divisionService.getAllDivisions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Division>) => {
      this.divisions = data;
    })
  }
  getAllLocations(filter: string) {
    this._locationService.getAllLocations(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Location>) => {
      this.locations = data;
    })
  }
  getAllDepartments(filter: string) {
    this._departmentService.getAllDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Department>) => {
      this.departments = data;
    })
  }
  getAllSubDepartments(Department_Id: string) {
    this._departmentService.GetAllDepartmentDetailsBySubdepartment(Department_Id).subscribe((data: Array<SubDepartment>) => {
      this.subdepartments = data;
    })
  }
  getAllUnits(filter: string) {
    this._unitService.getAllUnit(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Unit>) => {
      this.units = data;
    })
  }
  getAllDesignations(filter: string) {
    this._designationService.getAllDesignation(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Designation>) => {
      this.designations = data;
    })
  }
  getAllPositions(filter: string) {
    this._positionService.getAllPosition(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Position>) => {
      this.positions = data;
    })
  }

  SubDepartmentSelection(event: any) {
    // this.selectedSubDepartment = { SubDepartment_Id: '', SubDepartmentName: '' };
    this.getAllSubDepartments(this.entity.Department_Id);

  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      this.filterState = event.filter.filters[0].filters[0].value;

      //1 for gridfilter type
      this._employeeService.getAllEmployees(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((employees: Array<Employee>) => {
        this.employees = {
          data: employees,
          total: employees[0] ? employees[0].TotalCount : 0
        }
      });
    }
  }
  getAllEmployee() {
    this._employeeService.getAllEmployees('', Number(this.defaultPageSize), 1, 0, 0).subscribe((employees: Array<Employee>) => {
      this.employees = {
        data: employees,
        total: employees[0] ? employees[0].TotalCount : 0
      }
      const totalrows= employees[0].TotalCount 
      if(totalrows>10&&totalrows>50&&totalrows>100){
        this.pageSizes=  [10,50,100,totalrows] 
      }
     
    })
  };
  getAllUsers(filter: any) {
    if(filter)
    {
      this._employeeService.getAllUsers(filter, Number(this.defaultRowsCount), 1, 0, 0).subscribe((users: Array<Users>) => {
        this.userdata = users;
        return this.userdata;
  
      })

    }
    else{
      this._employeeService.getAllUsers('', Number(this.defaultRowsCount), 1, 0, 0).subscribe((users: Array<Users>) => {
        this.userdata = users;
        return this.userdata;
  
      })
    }
   
  };
  getAllSecretary(filter: any) {
    this._employeeService.getAll_SecretaryEmployees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<EmployeeSecretary>) => {
      let konst = data.filter(x=>x.Emp_Ref_Id!=this.entity.Emp_Ref_Id)
     // console.log('BOY',konst);
      this.secretarydata = konst;
    })
};

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._employeeService.deleteEmployee(this.selectedEmployee.Emp_Ref_Id).subscribe((Employee: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearEmployee();
            this.getAllEmployee();
          },
          )
        }
      }
    });

    // let multiselectFilter =document.getElementById("KendoMulti");
    // console.log(multiselectFilter);
  }

  initPageHeader(): PageHeader {
    let headerEmployee = new PageHeader();
    headerEmployee.PageCaption = "Employee";
    headerEmployee.IconClass = "bi bi-shield-shaded";
    return headerEmployee;
  }

  deleteEmployee(event: any) {
    if (event.seletedRows[0]) {
      this.selectedEmployee.Emp_Ref_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Employee",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addEmployee(event: any) {
    this.listView = false;
    this.HOStaff = true;
    this.clearEmployee();
    this.getAllCompanys('');
    this.getAllDivisions('');
    this.getAllLocations('');
    this.getAllDepartments('');
    this.SubDepartmentSelection('');
    this.getAllSalutation('');
    this.getAllUnits('');
    this.getAllDesignations('');
    this.getAllPositions('');
    this.getAllUsers('');
    this.getAllSecretary('');
    this.formCaption = "Add Employee";
    this.IsEdit = false;
    this.path = '';
    this.url = '';
  }
  checkValue() {
    if (this.entity.IsHOStaff == true) {
      this.HOStaff = false;
      this.selectedLocation = {};
      this.entity.Location_Id = '00000000-0000-0000-0000-000000000000';
      this.locations = [];
    }
    else {
      this.HOStaff = true;
      this.getAllLocations('');
    }

  }
  editEmployee(event: any): void {
    this.checkValue();
    if (event.seletedRows[0]) {
      this._employeeService.viewEmployee(event.seletedRows[0]).subscribe((employees: any) => {
        let editEnity = employees;
        if (editEnity) {
          console.log(editEnity);
          this.editingEntity = editEnity;
          this.selectedSalutation = { DisplayValue: editEnity.Salutation_Id, DisplayText: editEnity.Salutation };
          this.selectedLocation = { Location_Id: editEnity.Location_Id, LocationName: editEnity.LocationName };
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedDivision = { Division_Id: editEnity.Division_Id, DivisionName: editEnity.DivisionName };
          this.selectedDepartment = { Department_Id: editEnity.Department_Id, DepartmentName: editEnity.DepartmentName };
          this.selectedSubDepartment = { SubDepartment_Id: editEnity.SubDepartment_Id, SubDepartmentName: editEnity.SubDepartmentName };
          this.selectedUnit = { Unit_Id: editEnity.Unit_Id, UnitName: editEnity.UnitName };
          this.selectedDesignation = { Designation_Id: editEnity.Designation_Id, DesignationName: editEnity.DesignationName };
          this.selectedPosition = { Position_Id: editEnity.Position_Id, PositionName: editEnity.PositionName };
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Employee ";
          this.IsEdit = true;
         
          if (this.entity.FileName != null) {
            this.path = this.configService.getConfigValue('FileWriteLocation');
            this.url = this.path + this.entity.FileName;
          }
          else {
            this.path = '';
            this.url = '';
            this.entity.Document = null;
          }
          this.checkValue();
          this.getAllCompanys('');
          this.getAllDivisions('');
          this.getAllDepartments('');
          this.SubDepartmentSelection('');
          this.getAllSalutation('');
          this.getAllUnits('');
          this.getAllDesignations('');
          this.getAllPositions('');
          this.getAllUsers('');
          this.getAllSecretary('');
          this.entity.PrivateCommentsTo = this.editingEntity.PrivateCommentsTo;
          // this.entity.Secretary=this.editingEntity.Secretary;
          this.departments[0].Department_Id=this.selectedDepartment.Department_Id
          this.departments[0].DepartmentName=this.selectedDepartment.DepartmentName
          this.entity.EntityMetaData = [
            { FieldName: 'EmployeeCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Employee Code is required' },
            { FieldName: 'Salutation_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Salutation is required' },
            { FieldName: 'EmployeeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Employee Name is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
            { FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Branch is required' },
            { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department is required' }, 

          ];
        }
      });
    }
    
  }

  save(event: any): void {
    if (parseInt(this.entity.EmployeeCode) == 0) {
      this.notification.showWarning('zero not allowed');
      return
    }

    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._employeeService.checkDuplication(this.entity.EmployeeCode, this.entity.Emp_Ref_Id).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Employee Code already exists');
          this.saveDisabled = false;
        }
        else {
          if (this.entity.Phone != "") {

            const re = /^[6-9]{1}[0-9]{9}$/;
            this.contactCheck = re.test(String(this.entity.Phone).toString());
            if ((this.entity.Phone.length != 0 && this.entity.Phone.length != 10) || this.contactCheck == false) {
              this.notification.showWarning("Invalid Phone No.");
              this.saveDisabled = false;
              return
            }
            }
            if (this.entity.Department_Id == null||this.entity.Department_Id == undefined||this.entity.Department_Id == "") {
              this.notification.showWarning("Department is required");
              this.saveDisabled = false;
              return
            
            }
            // if(this.entity.Secretary.length<=0){
            //  this.notification.showWarning("Secretary name is required");
            //   this.saveDisabled = false;
            //   return
            // }

            // else {
              this._employeeService.checkPhone(this.entity.Phone, this.entity.Emp_Ref_Id).subscribe((response) => {

                if (response.Success == false) {
                  this.notification.showWarning("Phone Number already exists");
                  this.saveDisabled = false;
                  return
                }


                else {
                  if (this.entity.EmailId != "") {
                    // const re = /^[a-z0-9](\.?[a-z0-9]){1,}@+((esaf.bank|ESAF.BANK)\.in)||((gramproindia|GRAMPROINDIA)\.com)$/;
                    const re = /^[a-z0-9](\.?[a-z0-9]){1,}@+(?:(?:esaf.bank|ESAF.BANK)\.in|(?:gramproindia|GRAMPROINDIA)\.com)$/;
                    this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
                    if (this.emailcheck === false) {
                      this.notification.showWarning("Email not valid");
                      this.saveDisabled = false;
                    }
                    else {
                      this._employeeService.checkEmail(this.entity.EmailId, this.entity.Emp_Ref_Id).subscribe((response) => {
                        if (response.Success == false) {
                          this.notification.showWarning("Email already exists");
                          this.saveDisabled = false;
                          return;
                        } else {
                          if (this.entity.EmployeeCode != "" && this.entity.EmployeeCode.length > 10) {
                            this.notification.showWarning("Invalid Code!! ");
                            this.saveDisabled = false;
                            return;
                          }
                            this.users_list = [];
                            this.secretary_list=[];
                            if (this.entity.PrivateCommentsTo != undefined) {
                              for (let i = 0; i < this.entity.PrivateCommentsTo.length; i++) {
                                this.users_list.push({ User_Id: this.entity.PrivateCommentsTo[i].User_Id, UserName: this.entity.PrivateCommentsTo[i].UserName });
                              }
                            // }
                            if (this.entity.Secretary != undefined) {
                              for (let i = 0; i < this.entity.Secretary.length; i++) {
                                this.secretary_list.push({ Emp_Ref_Id: this.entity.Secretary[i].Emp_Ref_Id, secretaryName: this.entity.Secretary[i].secretaryName });
                              }
                            if (this.entity.Document != null && this.entity.Document != undefined) {
                              this.fileUploader.upload(this.entity.Document, '').subscribe((result: any) => {
                                if (result.succeeded) {
                                  this.entity.Ref_Id = result.documentId;
                                }
                                this._employeeService.saveEmployee(this.entity).subscribe(() => {
                                  if (this.entity.Emp_Ref_Id == '00000000-0000-0000-0000-000000000000') {
                                    this.notification.showSuccess('Saved Successfully');
                                  }
                                  else {
                                    this.notification.showSuccess('Updated Successfully');
                                  }
                                  this.listView = true;
                                  this.clearEmployee();
                                  this.getAllEmployee();
                                })
                              });
                            }
                            else {
                              this.entity.Ref_Id = null;
                              this._employeeService.saveEmployee(this.entity).subscribe(() => {
                                if (this.entity.Emp_Ref_Id == '00000000-0000-0000-0000-000000000000') {
                                  this.notification.showSuccess('Saved Successfully');
                                }
                                else {
                                  this.notification.showSuccess('Updated Successfully');
                                }
                                this.listView = true;
                                this.clearEmployee();
                                this.getAllEmployee();
                              })
                            }
                          }
                        }
                        }
                      });
                    }

                  }

                }
              });
            // }
          // }
          // else {
          //   this.entity.Ref_Id = null;
          //   this._employeeService.saveEmployee(this.entity).subscribe(() => {
          //     if (this.entity.Emp_Ref_Id == '00000000-0000-0000-0000-000000000000') {
          //       this.notification.showSuccess('Saved Successfully');
          //     }
          //     else {
          //       this.notification.showSuccess('Updated Successfully');
          //     }
          //     this.listView = true;
          //     this.clearEmployee();
          //     this.getAllEmployee();
          //   })
          // }
        }

      });
    }
    else {
      this.saveDisabled = false;
    }

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  checkContactNo(event: any): void {
    const re = /^[6-9]{1}[0-9]{9}$/;
    this.contactCheck = re.test(String(this.entity.Phone).toString());
    if (this.entity.Phone != "") {
      if (this.contactCheck == false) {
        this.notification.showWarning("Invalid Contact No");
        // this.notificationsService.showWarning("Invalid Contact No.");
        return;
      }
    }
  }

  gotoBack(): void {
    this.listView = true;
    this.getAllEmployee();
  }

  refreshEmployee(event:any): void {
    this.employees = [];
    this.getAllEmployee();
    this.filterState=''
  }

  clearEmployee(): void {
    this.entity = new Employee();
    this.saveDisabled=false;
    this.selectedCompany = {};
    this.selectedDivision = {};
    this.selectedLocation = {};
    this.selectedDepartment = {};
    this.selectedSalutation = {};
    this.selectedSubDepartment = {};
    this.selectedUnit = {};
    this.selectedDesignation = {};
    this.selectedPosition = {};
    this.entity = new Employee();
    this.saveDisabled = false;
    this.url = '';
    this.entity.Document = null;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  goToBackTab(): void {
    this.listView=true;
    window.location.reload()
}
  // fileChanged(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]);
  //     reader.onload = (event) => {
  //       this.url = String(event.target?.result); 
  //       // this.isButtonVisible = true;
  //     }
  //     this.entity.Document = event.target.files[0];
  //   }
  // } 

  // removeImage (event: any) {
  //   this.url = ''; 
  //   this.isButtonVisible = false;
  //   this.entity.Document = null;
  // }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Emp_Ref_Id = dataItem.Emp_Ref_Id;
    this.details = [];
    this._employeeService.viewEmployee(this.entity.Emp_Ref_Id).subscribe((employees: Array<Employee>) => {
      this.opened = true;
      this.details = employees;
      this.PrivateComments="Private Comments To"
    })
  }
}
